export const ResultSource = {
  Query: 1,
  SP: 2,
  View: 3,
  DataElement: 4
};

export const RowActions = {
  Show: 1,
  Navigate: 2,
};
